import React, { useState, useEffect } from 'react';
import taskService from './services/taskService';
import userService from './services/userService';

const TaskAPITest = () => {
  const [tasks, setTasks] = useState([]);
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const testAPIs = async () => {
      console.log('🧪 Testing Task API...');
      setLoading(true);

      try {
        // Test tasks API
        console.log('📋 Calling taskService.getTasks()...');
        const tasksResponse = await taskService.getTasks();
        console.log('📋 Tasks response:', tasksResponse);

        if (tasksResponse.success) {
          setTasks(tasksResponse.data || []);
          console.log('✅ Tasks loaded:', tasksResponse.data?.length || 0);
        } else {
          console.log('❌ Tasks failed:', tasksResponse.message);
        }

        // Test users API
        console.log('👥 Calling userService.getUsers()...');
        const usersResponse = await userService.getUsers();
        console.log('👥 Users response:', usersResponse);

        if (usersResponse.success) {
          setUsers(usersResponse.data || []);
          console.log('✅ Users loaded:', usersResponse.data?.length || 0);
        } else {
          console.log('❌ Users failed:', usersResponse.message);
        }

      } catch (err) {
        console.error('💥 API Test Error:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    testAPIs();
  }, []);

  return (
    <div style={{ padding: '20px' }}>
      <h1>🧪 API Test Page</h1>
      <p>Check the browser console for detailed API logs.</p>

      {loading && <p>🔄 Testing APIs...</p>}
      {error && <p style={{color: 'red'}}>❌ Error: {error}</p>}

      <div style={{ marginTop: '20px' }}>
        <h3>📋 Tasks ({tasks.length})</h3>
        {tasks.length > 0 ? (
          <ul>
            {tasks.slice(0, 5).map((task, index) => (
              <li key={index}>{task.title || task.name || 'Untitled'}</li>
            ))}
          </ul>
        ) : (
          <p>No tasks found or API failed</p>
        )}
      </div>

      <div style={{ marginTop: '20px' }}>
        <h3>👥 Users ({users.length})</h3>
        {users.length > 0 ? (
          <ul>
            {users.slice(0, 5).map((user, index) => (
              <li key={index}>{user.name || user.email || 'Unknown'}</li>
            ))}
          </ul>
        ) : (
          <p>No users found or API failed</p>
        )}
      </div>
    </div>
  );
};

export default TaskAPITest;